import { UserType } from "../../libs/user/User"

export type TipoPersona = {
    tipoPersona: 'fisica' | 'giuridica' | undefined
}

export type FisicaType = TipoPersona & {
    nome: string | undefined
    cognome: string | undefined
    
    indirizzoResidenza_SedeLegale: string | undefined
    street: string | undefined
    street_number: string | undefined
    zip: string | undefined
    city: string | undefined

    is_manual_address: boolean

    natoInItalia: boolean | undefined
    sesso: number | undefined
    data_nascita:  string | undefined
    stato_nascita: number | undefined
    comune_nascita: string | undefined
    professione: string | undefined

    email: string | undefined
    cellulare: string | undefined

    selectPeopleId: string | undefined
}


export interface FisicaState {
    tipoPersona: 'fisica' | 'giuridica' | undefined
    
    email: string | undefined
    cellulare: string | undefined

    nome: string | undefined
    cognome: string | undefined
    
    indirizzoResidenza_SedeLegale: string | undefined
    street: string | undefined
    street_number: string | undefined
    zip: string | undefined
    city: string | undefined

    is_manual_address: boolean

    natoInItalia: boolean | undefined
    sesso: number | undefined
    data_nascita:  string | undefined
    stato_nascita: number | undefined
    comune_nascita: string | undefined

    professione: string | undefined
   
    selectPeopleId: string | undefined

    tipoPersonaError?: string | undefined

    emailError?: string | undefined
    cellulareError?: string | undefined

    nomeError?: string | undefined
    cognomeError?: string | undefined

    indirizzoError?: string | undefined
    streetError?: string | undefined
    street_numberError?: string | undefined
    zipError?: string | undefined
    cityError?: string | undefined

    natoInItaliaError?: string | undefined
    sessoError?: string | undefined
    data_nascitaError?: string | undefined
    stato_nascitaError?: string | undefined
    comune_nascitaError?: string | undefined

    professioneError?: string | undefined

    selectPeopleIdError?: string | undefined

    profList: any | undefined
    sessoList: any | undefined
    statiList: any | undefined
}

export interface PeopleProps <T extends FisicaType>  {
    people: T | undefined
    updatePeopleCallback: Function

    user: UserType | undefined
    updateUserCallBack: Function

    expiredSessionCallbak: Function
    
    error?: string | undefined
}

export function getPeopleAddress (
    street: string | undefined,
    street_number: string | undefined,
    zip: string | undefined,
    city: string | undefined,
    indirizzo: string | undefined
) {
    return (
        street &&
        street_number &&
        zip &&
        city
    )
        ? street + ', ' + street_number + ', ' + zip + ' ' + city + ', ITALIA'
        : indirizzo
}